var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPayshapInfo5 = function SvgPayshapInfo5(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3168_6948)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3587 49.9037C24.4923 50.6339 23.1973 50.6191 22.3467 49.8279L18.8107 46.539C17.8908 45.6833 17.8391 44.2436 18.6954 43.3243L38.8207 21.7164C40.5247 19.8856 43.3826 19.7866 45.2135 21.4906L45.4484 21.707C47.0805 23.2261 47.3363 25.6622 46.1654 27.4701L47.5725 25.9584C49.2765 24.1276 52.1345 24.0286 53.9653 25.7326L54.2002 25.949C56.031 27.653 56.13 30.5109 54.426 32.3418L39.0573 48.8639L52.6952 34.2212C54.3992 32.3904 57.2571 32.2914 59.088 33.9954L59.3229 34.2118C61.1537 35.9158 61.2527 38.7737 59.5487 40.6046L53.6337 46.9601C54.8313 46.884 56.057 47.2828 57.0064 48.1664L57.2413 48.3828C59.0722 50.0868 59.1711 52.9447 57.4671 54.7756L45.0425 68.0521C44.1863 68.9671 42.7512 69.0168 41.8337 68.1634L38.2981 64.8748C37.7439 64.3593 37.5049 63.6322 37.5894 62.9345C37.096 62.8956 36.6118 62.696 36.2212 62.3327L32.6852 59.0438C31.8023 58.2225 31.7192 56.8635 32.4709 55.9426C31.6102 56.8085 30.2113 56.8413 29.3106 56.0035L25.7746 52.7145C24.9805 51.9759 24.8334 50.8023 25.3587 49.9037Z",
    fill: "#F15A22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1604 77.0452L33.2938 80.805C32.7323 81.2388 32.0005 81.3856 31.3151 81.2019L5.38929 74.2551C4.35487 73.978 3.59426 73.0977 3.47008 72.034L1.37505 54.0879C1.34619 53.8407 1.3528 53.5906 1.39468 53.3452L4.71882 33.8705C4.93171 32.6232 6.02592 31.6689 7.24882 31.9937C10.8245 32.9436 13.7989 36.2013 13.6718 39.8989L13.2352 51.8628C13.2019 52.7737 13.7158 53.6163 14.5408 54.0038L43.1288 67.4319C43.9927 67.8377 44.4714 68.742 44.0826 69.6137C43.4168 71.1064 41.8466 73.6588 38.1604 77.0452Z",
    fill: "#F15A22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.715 13.2713L25.6202 4.67152C24.4072 4.34649 23.1603 5.06635 22.8353 6.27936L7.514 63.4593C7.18898 64.6723 7.90883 65.9191 9.12184 66.2441L41.2166 74.8439C42.4296 75.1689 43.6765 74.4491 44.0015 73.2361L47.5376 60.0393L59.3228 16.0562C59.6478 14.8431 58.928 13.5963 57.715 13.2713Z",
    fill: "white",
    stroke: "#F15A22",
    strokeWidth: 1.51589
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.2324,
    y: 18.9644,
    width: 24.6453,
    height: 24.6453,
    rx: 1,
    transform: "rotate(15 26.2324 18.9644)",
    fill: "#F15A22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5072 17.2476L25.0616 15.5205C24.5282 15.3776 23.9798 15.6942 23.8369 16.2276L22.1098 22.6732M18.138 37.4963L16.4109 43.9419C16.2679 44.4753 16.5845 45.0237 17.118 45.1666L23.5636 46.8937M38.3866 50.8655L44.8322 52.5926C45.3657 52.7356 45.914 52.419 46.057 51.8855L47.7841 45.4399M51.7559 30.6169L53.483 24.1713C53.6259 23.6378 53.3093 23.0895 52.7759 22.9465L46.3303 21.2195",
    stroke: "#FC4D0F",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.4336,
    y: 53.8059,
    width: 23.6091,
    height: 2.36091,
    transform: "rotate(15 17.4336 53.8059)",
    fill: "#F15A22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.6328,
    y: 59.2837,
    width: 16.5264,
    height: 2.36091,
    transform: "rotate(15 19.6328 59.2837)",
    fill: "#F15A22"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3168_6948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9801 26.1968L30.6996 25.5858C30.2798 25.4733 29.8483 25.7224 29.7358 26.1422L29.1247 28.4227C29.0122 28.8425 29.2614 29.2741 29.6812 29.3865L31.9617 29.9976C32.3815 30.1101 32.813 29.8609 32.9255 29.4411L33.5366 27.1607C33.649 26.7408 33.3999 26.3093 32.9801 26.1968Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8609 28.8445L40.5805 28.2335C40.1606 28.121 39.7291 28.3701 39.6166 28.7899L39.0056 31.0704C38.8931 31.4902 39.1422 31.9218 39.5621 32.0342L41.8425 32.6453C42.2623 32.7578 42.6939 32.5086 42.8064 32.0888L43.4174 29.8084C43.5299 29.3885 43.2808 28.957 42.8609 28.8445Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3316 36.0786L28.0512 35.4676C27.6313 35.3551 27.1998 35.6042 27.0873 36.0241L26.4763 38.3045C26.3638 38.7244 26.6129 39.1559 27.0328 39.2684L29.3132 39.8794C29.733 39.9919 30.1646 39.7428 30.2771 39.323L30.8881 37.0425C31.0006 36.6227 30.7515 36.1911 30.3316 36.0786Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9746 38.9303L38.6941 38.3192C38.2909 38.2112 37.8613 38.2678 37.4998 38.4765C37.1383 38.6852 36.8745 39.029 36.7665 39.4322L36.1554 41.7126",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9551 42.7312L39.9529 42.7393",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9648 30.2557L35.3538 32.5362C35.2458 32.9394 34.982 33.2832 34.6205 33.4919C34.2589 33.7006 33.8293 33.7572 33.4261 33.6491L31.1456 33.0381",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1055 32.2234L28.1136 32.2256",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7812 27.2151L36.7894 27.2173",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1328 37.0972L34.1306 37.1053",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9883 34.8713L38.7484 35.075",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7891 35.8896L41.7869 35.8978",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1147 40.8979L33.3184 40.1377",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.7194 12.1507C35.8722 11.5803 36.4585 11.2418 37.0288 11.3946L43.7417 13.1934C44.3121 13.3462 44.6506 13.9325 44.4977 14.5028C44.3449 15.0732 43.7586 15.4117 43.1883 15.2589L36.4754 13.4601C35.905 13.3073 35.5665 12.721 35.7194 12.1507Z",
    fill: "#F15A22"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3168_6948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3168_6948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.8873,
    height: 18.8873,
    fill: "white",
    transform: "translate(28.2695 22.4905) rotate(15)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPayshapInfo5, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/payshap_info_5.2f942a3d.svg";
export { ForwardRef as ReactComponent };